import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import Component from './entity/Component';
import { getAnchorIdFromEntity } from './Anchor';

class Block extends Component {

  renderBlockFromDocument(extraAttributes, onClickCallback, customEvent, index) {
    const document = this.getDocument();

    if (document && document.fields && document.fields.contentType) {
      let contentType = document.fields.contentType;
      let blockName = document.fields.name;
      let className = document.fields.classNames;

      let attributes = {
        name: blockName,
        document: document,
        className: className,
        onClickCallback,
        customEvent,
        key: blockName,
        index,
        ...extraAttributes
      };

      return this.renderBlock(contentType, attributes, null);

    } else {
      console.error('Unsupported block is currently assign to page:' + this.props?.page?.fields?.name);
    }
  }

  /**
   * Render the modules assigned to the page.
   * @returns {*}
   */
  renderChildBlocks(extraAttributes, onClickCallback, customEvent) {
    const doc = this.getDocument();

    return ((doc.fields && doc.fields.blocks) ?
      <Fragment>
        { doc.fields.blocks.map((child, index) => (
            new Block(child).renderBlockFromDocument(extraAttributes, onClickCallback, customEvent, index)
        ))}
      </Fragment>
    :
      null
    );
  }

  getAnchorId() {
    return getAnchorIdFromEntity(this.getDocument());
  }

  getShortName() {
    let shortName = this.getFieldValue('shortName');

    if (shortName == null) {
      shortName = this.getFieldValue('anchorId');
    }

    if (shortName == null) {
      shortName = this.getFieldValue('name');
    }

    return shortName;
  }
  renderSpecifiedBlock(blockToRender){
    return ((blockToRender) ?
      <Fragment>
        {blockToRender.map((child) => (
            new Block(child).renderBlockFromDocument()
        ))}
      </Fragment>
    :
      null
    );  
  }
}

Block.propTypes = {
  page: PropTypes.object
}

export default Block
